module.exports = __webpack_public_path__ + "img/Restaurant location pin Icon - white.775458ca.svg";